import { atom, useAtom } from "jotai";
import { State } from "./State";
import axios from "axios";
import { fetchBase, postBase } from "./BaseApi";

export type UsersQuiz = {
  userId: string;
  quizList: {
    quizId: string;
    classificationName: string;
    categoryName: string;
    title: string;
    explanation: string;
    tag: string;
    image: string;
    completedDate: string;
    acquiredBadgeType: string;
    totalCorrectNumber: number;
  }[];
};

type Param = {
  quizClassification: "education" | "financial" | 'all';
};

const uri = "api/users/quiz";

export const fetchUsersQuizAtom = atom<State<UsersQuiz> | null>(null);
export const fetchUsersQuiz = () => {
  return fetchBase<UsersQuiz, Param>(uri, fetchUsersQuizAtom);
};

export type UsersQuizResult = {
  quizId: string;
  isAcquiredBadgeType: true;
  badgeTitle: string;
  acquiredBadgeType: string;
  badgeExplanation: string;
  badgeImageData: string;
  supportLink: string;
  isAcquiredPoint: boolean;
  preAcquiredPoint: number;
  currentAcquiredPoint: number;
  prevBadgeTitle: string;
  acquiredPointOwnerList: {
    pointOwnerId: number;
    ownerType: "user" | "child";
    ownerName: string;
    iconType: string | null;
    displayOrder: number;
  }[];
};

export type AnswerItem = {
  isCorrect: number;    // 正解の場合は 1、不正解の場合は 0
  quizSequence: number; // クイズの問題番号
};

type PostUsersQuizParam = {
  quizId: string;
  totalCorrectAnswer: number;
  answerList: AnswerItem[]; // みんなの正答率のために追加
};

export const postUserQuizAtom = atom<State<UsersQuizResult> | null>(null);

export const postUsersQuiz = () => {
  return postBase<UsersQuizResult, PostUsersQuizParam>(uri, postUserQuizAtom);
};
